import { StyleSheet } from 'react-native';
import { PALETTE, MQ_TABLET} from '../../../constants';
import { MediaQueryStyleSheet } from "react-native-responsive";
// import ResponsiveDimensionValues from '../../common/responsive-dimension-values';
// const WINDOW_WIDTH = ResponsiveDimensionValues.windowWidth;

export default MediaQueryStyleSheet.create({
  mainWrapper:{
    flex:1,
    flexDirection: 'column',
  },
   headline: {
    textAlign: 'center',
    marginBottom: 40,
  },
  root:{
    paddingLeft: 25,
    paddingRight: 25,
    flex:1,
    flexDirection: 'column',
    alignItems: 'center',
    
  },
  buttonContinue:{
    width:296,
  },
  message:{
    textAlign: 'center',
    marginTop:-20,
    paddingLeft:30,
    paddingRight:30,
  },
  messageText:{
    textAlign: 'center',
    color:'red',
    marginTop:10,
  },
  skiplink:{
    fontSize: 20,
    textAlign: 'center',
    color: '#E29317',

  },
  alignBottom:{
     position: 'absolute', bottom:40, left: 40, right: 40,
     alignItems:'center',
  },

  label:{
    backgroundColor:'transparent',
  },

    rowStyle:{
      flex:1,
      flexDirection: 'row',
      marginTop:10,
      marginBottom:5,
      backgroundColor: 'transparent',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingLeft: 10,
      paddingRight: 20,
      marginLeft:10,
      marginRight:10,
    },
    firstItem:{
     
      color: 'white',
      textAlign:'left',
      flex:7,
      flexDirection: 'column',
      justifyContent: 'flex-start',
    },
    secondItem:{
      //width:38,
      color: 'white',
      textAlign:'left',
      flex:1,
      flexDirection: 'column',
      justifyContent: 'flex-start',
      flexWrap: 'nowrap',
    },
    thirdItem:{
     flex:6,
      color: 'white',
      textAlign:'right',
    },
    mobileListWrapper:{
      marginBottom:15,
    },
    checkboxStyle: {
        //flex:6,
        height: 24,
        borderWidth: 1,
        borderColor: '#FFF',
        borderRadius: 3
    },

   rowBorder: {
      height: 1,
      backgroundColor: 'rgba(153,153,153,0.5)',
      flex:1,
      marginLeft:15,
      marginRight:10,
    },


  listWrpper:{marginTop:20,marginLeft:20,paddingLeft:20,paddingRight:20,},
  listWrpperView:{flexDirection:'row',backgroundColor:'transparent'},
  listWrpperTop:{flexDirection:'row',backgroundColor:'transparent',marginTop:15},
  listIcon:{
     borderWidth: 2,borderColor: '#FFF',borderRadius: 2,width:2,height:2,marginTop:10,
  },
  listText:{
    marginLeft:15,color:'#FFF',
  },
  deselctAllLink:{
    flexDirection:'row',backgroundColor:'transparent',marginBottom:10,
    marginTop:20,
    width:296,
  },
  selectedCount:{
    flex:3,
    justifyContent:'flex-end'
  },
  bottomPadding:{
    paddingBottom:30,
  },
  backLink: {
    flex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-start',
    position: 'absolute',
    top: -72,
  },
  warningMsg:{
        flex:1,
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'center',
   },
   msgText:{
    color:'white',
    backgroundColor:'transparent',
   }

},
{
 [MQ_TABLET]: {
  mainWrapper:{

  },
  listWrpper:{
    flex:0.6,
    paddingTop:30,
  },
  messageWrapper:{
    marginRight:30,
    marginLeft:30,
  },
  root:{
    //width:WINDOW_WIDTH*0.7,
    alignSelf:'center',
  },
  deselctAllLink:{
    marginBottom:30,marginTop:30,
  },
  changeFlex:{
    flexDirection:'row',
    flex:0.6,
  },
  blockList:{
    //width:WINDOW_WIDTH*0.8,
    flexDirection: 'row',
    alignSelf:'center',
    alignItems:'center',
    marginBottom:30,
    marginTop:30,
     //marginLeft:30,
    
 },
 fleWrapper:{
    flexDirection: 'row',
    flexWrap:'wrap',flex:1,
  },
  tabletList:{
    borderWidth: 1,
    borderColor: PALETTE.primaryStrokeLine,
    backgroundColor:'transparent',
    flexDirection: 'column',
   // width:WINDOW_WIDTH*0.18,
    marginBottom:30,
    marginLeft:10,
    marginRight:10,
    height:120,
    alignItems:'center',
  },
  checkBoxWrapper:{
    flex:1,
    alignItems:'center',
    marginTop:20,
    marginBottom:10,
    flexDirection:'row',
  },
  checkboxStyle:{
    justifyContent:'center',
    alignSelf:'center',
    marginRight:-20,
  },
  firstItem:{
    justifyContent:'center',
    textAlign:'center',
    flex:1,
  },
  secondItem:{
    justifyContent:'center',
    textAlign:'center',
    flex:1,
  },
  thirdItem:{
    justifyContent:'center',
    flex:1,
    textAlign:'center',
  },
  rowBorder:{
     //width:WINDOW_WIDTH*0.8,
     alignSelf:'center',
  }

  }
});

